var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup25847(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.671,
    height: 123.77,
    viewBox: "0 0 133.671 123.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wa47bg1yga",
    x1: -0.38,
    y1: -1.317,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c4191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612166"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vwe34exuab",
    x: 42.359,
    y: 52.807,
    width: 49.17,
    height: 50.537,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25847"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24906",
    d: "M24.754 0h84.163a24.754 24.754 0 0 1 24.754 24.754v74.262a24.754 24.754 0 0 1-24.754 24.754H24.754A24.754 24.754 0 0 1 0 99.016V24.754A24.754 24.754 0 0 1 24.754 0z",
    style: {
      fill: "url(#wa47bg1yga)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25566"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#vwe34exuab)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7589",
    d: "M-371.687 251.4a15.493 15.493 0 0 0-1.577 6.8c0 8.607 15.585 25.739 15.585 25.739s15.585-17.132 15.585-25.739a15.5 15.5 0 0 0-1.578-6.8 42.224 42.224 0 0 1-14.008 2.1 42.227 42.227 0 0 1-14.007-2.1zm18.757 8.707a4.75 4.75 0 0 1-4.749 4.75 4.75 4.75 0 0 1-4.75-4.75 4.75 4.75 0 0 1 4.75-4.75 4.75 4.75 0 0 1 4.749 4.743z",
    transform: "translate(424.619 -192.59)",
    style: {
      fill: "#fdfdfd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7590",
    d: "m-374.677 227.47.937-.346a42.263 42.263 0 0 1 14.052-2.1 42.267 42.267 0 0 1 14.052 2.1l.937.346.327.943.369 1.066c2.29-1.577 4.117-3.359 4.28-5.865-.22-3.389-3.481-5.458-6.821-7.482-3.556-1.9-7.19-3.757-13.145-3.882-5.955.125-9.589 1.981-13.145 3.882-3.339 2.024-6.6 4.092-6.82 7.482.162 2.506 1.99 4.287 4.279 5.865l.37-1.065z",
    transform: "translate(426.632 -180.281)",
    style: {
      fill: "#fdfdfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7591",
    d: "M-373.443 242.816c3.058 1.839 8.945 3.086 15.708 3.086s12.651-1.246 15.708-3.086l-2.386-6.886a40.4 40.4 0 0 0-13.322-1.972 40.4 40.4 0 0 0-13.322 1.972z",
    transform: "translate(424.679 -187.107)",
    style: {
      fill: "#fdfdfd"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25847);
export default __webpack_public_path__ + "static/media/Group 25847.2e30fe8aeaa2ea8013144d93e476707a.svg";
export { ForwardRef as ReactComponent };